import { render, staticRenderFns } from "./manualsep.vue?vue&type=template&id=bd4e0060&scoped=true&"
import script from "./manualsep.vue?vue&type=script&lang=js&"
export * from "./manualsep.vue?vue&type=script&lang=js&"
import style0 from "./manualsep.vue?vue&type=style&index=0&id=bd4e0060&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bd4e0060",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\xampp\\htdocs\\SNS_Thai\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('bd4e0060')) {
      api.createRecord('bd4e0060', component.options)
    } else {
      api.reload('bd4e0060', component.options)
    }
    module.hot.accept("./manualsep.vue?vue&type=template&id=bd4e0060&scoped=true&", function () {
      api.rerender('bd4e0060', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/social/manualsep.vue"
export default component.exports